import { tokPx } from '@sunwebgroup/ui-components'
import { focusOutline } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

export const OverlayLink = styled.a`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: ${tokPx('semantics_cards_corner_radius')};

  ${focusOutline()}
`
